import { FC, Fragment, ReactNode } from "react";
import { Link } from "react-router-dom";
import { usePageSeo } from "../UseSeoComponent";
import LinkSidebar from "../LinkSidebar";

export interface Crumb {
  label: string;
  to?: string;
}

interface InnerPageProps {
  eyebrow: string;
  title: string;
  crumbs: Crumb[];
  seoDescription: string;
  withSidebar?: boolean;
  children: ReactNode;
}

const InnerPage: FC<InnerPageProps> = ({
  eyebrow,
  title,
  crumbs,
  seoDescription,
  withSidebar = false,
  children,
}) => {
  usePageSeo(`${title} | Securitas İtfaiye`, seoDescription);

  return (
    <>
      <section className="it-phero">
        <div className="it-wrap">
          <div className="it-eyebrow">{eyebrow}</div>
          <h1>{title}</h1>
          <nav className="it-crumb" aria-label="Sayfa yolu">
            <Link to="/">Anasayfa</Link>
            {crumbs.map((crumb) => (
              <Fragment key={crumb.label}>
                <span className="sep">/</span>
                {crumb.to ? (
                  <Link to={crumb.to}>{crumb.label}</Link>
                ) : (
                  <span>{crumb.label}</span>
                )}
              </Fragment>
            ))}
          </nav>
        </div>
      </section>
      <section className="it-content">
        <div className={`it-wrap it-cgrid${withSidebar ? " it-cgrid--side" : ""}`}>
          {children}
          {withSidebar && <LinkSidebar />}
        </div>
      </section>
    </>
  );
};

export default InnerPage;
